import zhCN from './zh-CN'
import enUS from './en-US'

const messages = {
  'zh-CN': zhCN,
  'en-US': enUS
}

function resolve(obj, path) {
  return path.split('.').reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj)
}

export function translate(locale, key) {
  const value = resolve(messages[locale] || messages['zh-CN'], key)
  return value !== undefined ? value : key
}

export function installI18n(Vue, store) {
  Vue.prototype.$t = function (key) {
    return translate(store.state.locale, key)
  }

  Vue.prototype.$setLocale = function (locale) {
    store.commit('setLocale', locale)
  }

  Vue.mixin({
    computed: {
      currentLocale() {
        return this.$store.state.locale
      },
      isEn() {
        return this.$store.state.locale === 'en-US'
      }
    }
  })
}

export default { messages, translate }
